module.exports = __webpack_public_path__ + "img/DOUBLEBET.8c32e9b7.svg";